import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/crmservices'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import {getAppCfg, getBrowser, getCountryDefault} from '../../utils/common'
import { connection } from '../../../portal.config';
import IdentifyView from './IdentifyView';
import RegisterVerificationView from '../register/RegisterVerificationView';
import CredentialsController from './CredentialsController';
import { CyprusFlagIcon } from '../../components/icons';
const styles = theme => ({

});
function IdentifyController(props){
    const config = getAppCfg()
    let agreement_countries = config&&config.contact&&config.contact.agreement_countries?config.contact.agreement_countries:null
    let country_default = getCountryDefault(agreement_countries);

    const [active, setActive] = useState('main');
    const [method_select, onSelectMethod] = useState('PHONE');
    const [verify_type, onSelectVerify] = useState('EMAIL');
    const [showLoading, onShowLoading] = useState(false);
    const [error, setError] = useState({});
    const [register_info, setRegisterInfo] = useState({country_code: country_default.value});
    const [country_select, onSelectCountry] = useState(country_default);
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState('');
    const [validation, setValiadation] = useState({});
    const [contact, setContact] = useState(null);



    const onRegister = async(values) => {
       
        let temp_register_info = {...register_info}
        temp_register_info[method_select] = values[method_select];
        
        //console.log('Identify register_info=== ', register_info)
        onShowLoading(true);
        setRegisterInfo(prevState => ({
            ...prevState,
            [method_select]: values[method_select]
        }));

        try {
            let result = await crmServices.contacts.sendCredentialsOTP({ send_method: verify_type , name: method_select, value: temp_register_info[method_select] });
            console.log('onRegister===',result)
            if (result.code == 'OK') {
                onShowLoading(false);
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                    setObfuscatedValue(result.data.obfuscated_value);
                }
                setActive('verify');
            } else {
                showAlert('ERROR', t(result.code));
            }
        } catch (error) {
            console.log("register by phone exception:", error);
            showAlert('ERROR', t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onVerifyOTP = async(code) => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.validateCredentialsOTP({ phone: null, auth_otp: auth_otp, otp: code.verification_code });
            console.log('result=======', result)
            if (result.code === 'OK') {
                setContact(result.data)
                onShowLoading(false);
                setActive('auth-cre')
            } else {
                showAlert('ERROR', t('INVALID_OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const onResendCode = async () => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.sendCredentialsOTP({ send_method: verify_type , name: method_select, value: register_info[method_select] });
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp)
                }
                if(verify_type==='email')
                    showAlert('ERROR', t('OTP_RESEND_EMAIL_SUCCESS'));
                else
                    showAlert('ERROR', t('OTP_RESEND_SUCCESS'));
                
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }
    const showAlert = async (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = async () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }

    return (
        <div>
        {active==='main'&&<IdentifyView
            onSubmit={onRegister}
            showAlert={showAlert}
            onShowLoading={onShowLoading}
            register_info = {register_info}
            method_select = {method_select}
            country_select = {country_select}
            verify_type = {verify_type}
            onSelectVerify={onSelectVerify}
            onSelectMethod={onSelectMethod}
            agreement_countries={agreement_countries}
            onSelectCountry={onSelectCountry}/>}
        {active==='verify'&&<RegisterVerificationView
            onSubmit={onVerifyOTP}
            onResend={onResendCode}
            obfuscated_value={obfuscated_value}
            email = {verify_type==='EMAIL'}/>}    
        {active === 'auth-cre' &&<CredentialsController
            navigation={props.navigation}
            contact={contact}
            />}
        <ModalAlert
            open={error.showAlert}
            onClose={onCloseAlert}
            hideHeader={true}
            message={error.message}
            error={error.status}
            title={error.title}
        />
        {showLoading && <Loading showLoading={showLoading} />}
        </div>

    );
}

export default withStyles(styles)(withTranslation()(IdentifyController));